document.addEventListener('DOMContentLoaded', function () {

  // Request form hotels
  let selectedHotelsDiv = document.getElementById("selected-hotels");
  let selectedHotelsInput = document.getElementById("selected_hotels_email");
  let selectedHotelsNamesInput = document.getElementById("selected_hotels_names");
  let checkboxes = document.querySelectorAll(".hotel-checkbox");
  let confirmButton = document.getElementById("confirmHotels");

  checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function () {
          let selectedCheckboxes = document.querySelectorAll(".hotel-checkbox:checked");
          
          if (selectedCheckboxes.length > 4) {
              this.checked = false;
              return;
          }

          updateHotelSelection();
      });
  });

  function updateHotelSelection() {
      let selectedCheckboxes = document.querySelectorAll(".hotel-checkbox:checked");
      let allHotels = document.querySelectorAll(".hotel-checkbox");
      
      let selectedData = [];
      let selectedNamesData = [];

      allHotels.forEach(checkbox => {
          let hotelWrapper = checkbox.closest(".col-lg-3");

          if (checkbox.checked) {
              hotelWrapper.classList.add("selected-hotel");
              if (!hotelWrapper.querySelector(".remove-hotel")) {
                  let removeIcon = document.createElement("i");
                  removeIcon.classList.add("icon-close", "remove-hotel");
                  removeIcon.addEventListener("click", function () {
                      checkbox.checked = false;
                      updateHotelSelection();
                  });
                  hotelWrapper.appendChild(removeIcon);
              }
          } else {
              hotelWrapper.classList.remove("selected-hotel");
              let removeIcon = hotelWrapper.querySelector(".remove-hotel");
              if (removeIcon) removeIcon.remove();
          }
      });

      selectedCheckboxes.forEach(checkbox => {
          let name = checkbox.getAttribute("data-name");
          let email = checkbox.getAttribute("data-email");
          selectedData.push(email);
          selectedNamesData.push(name);
      });

      // Ažuriranje skrivenih input polja
      selectedHotelsInput.value = selectedData.join(", ");
      selectedHotelsNamesInput.value = selectedNamesData.join(", ");

      // Ako su 4 selektovana, ostali postaju manje vidljivi
      if (selectedCheckboxes.length >= 4) {
          allHotels.forEach(checkbox => {
              let hotelWrapper = checkbox.closest(".col-lg-3");
              if (!checkbox.checked) {
                  hotelWrapper.classList.add("disabled-hotel");
              }
          });
      } else {
          allHotels.forEach(checkbox => {
              let hotelWrapper = checkbox.closest(".col-lg-3");
              hotelWrapper.classList.remove("disabled-hotel");
          });
      }
  }

  confirmButton.addEventListener("click", function () {
      updateSelectedHotelsView();
      $("#hotelModal").modal("hide");
  });

  function updateSelectedHotelsView() {
      let selectedCheckboxes = document.querySelectorAll(".hotel-checkbox:checked");

      // Resetujemo prikaz
      selectedHotelsDiv.innerHTML = "";
      let chooseBox = document.createElement("div");
      chooseBox.classList.add("col-lg-3", "choose-hotel-wrapper");
      chooseBox.innerHTML = `
          <div class="choose-hotel" data-toggle="modal" data-target="#hotelModal">
              <i class="icon-plus"></i>
          </div>
          <p class="mt-1">Neue auswählen</p>
      `;
      selectedHotelsDiv.appendChild(chooseBox);

      selectedCheckboxes.forEach(checkbox => {
          let name = checkbox.getAttribute("data-name");
          let image = checkbox.getAttribute("data-image");

          let hotelDiv = document.createElement("div");
          hotelDiv.classList.add("col-lg-3", "selected-hotel-box");
          hotelDiv.innerHTML = `
              <img src="${image}" class="img-fluid"> 
              <p class="mt-1">${name}</p>
          `;
          selectedHotelsDiv.insertBefore(hotelDiv, chooseBox);
      });
  }



  // Request form guides
  let selectedGuidesDiv = document.getElementById("selected-guides");
  let selectedGuidesInput = document.getElementById("selected_guides_email");
  let selectedGuidesNamesInput = document.getElementById("selected_guides_names");
  let guideCheckboxes = document.querySelectorAll(".guide-checkbox");
  let confirmGuidesButton = document.getElementById("confirmguides");

  guideCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function () {
          let selectedCheckboxes = document.querySelectorAll(".guide-checkbox:checked");
          
          if (selectedCheckboxes.length > 4) {
              this.checked = false;
              return;
          }

          updateGuideSelection();
      });
  });

  function updateGuideSelection() {
      let selectedCheckboxes = document.querySelectorAll(".guide-checkbox:checked");
      let allGuides = document.querySelectorAll(".guide-checkbox");
      
      let selectedData = [];
      let selectedNamesData = [];

      allGuides.forEach(checkbox => {
          let guideWrapper = checkbox.closest(".col-lg-3");

          if (checkbox.checked) {
              guideWrapper.classList.add("selected-guide");
              if (!guideWrapper.querySelector(".remove-guide")) {
                  let removeIcon = document.createElement("i");
                  removeIcon.classList.add("icon-close", "remove-guide");
                  removeIcon.addEventListener("click", function () {
                      checkbox.checked = false;
                      updateGuideSelection();
                  });
                  guideWrapper.appendChild(removeIcon);
              }
          } else {
              guideWrapper.classList.remove("selected-guide");
              let removeIcon = guideWrapper.querySelector(".remove-guide");
              if (removeIcon) removeIcon.remove();
          }
      });

      selectedCheckboxes.forEach(checkbox => {
          let name = checkbox.getAttribute("data-name");
          let email = checkbox.getAttribute("data-email");
          selectedData.push(email);
          selectedNamesData.push(name);
      });

      // Ažuriranje skrivenih input polja
      selectedGuidesInput.value = selectedData.join(", ");
      selectedGuidesNamesInput.value = selectedNamesData.join(", ");

      // Ako su 4 selektovana, ostali postaju manje vidljivi
      if (selectedCheckboxes.length >= 4) {
          allGuides.forEach(checkbox => {
              let guideWrapper = checkbox.closest(".col-lg-3");
              if (!checkbox.checked) {
                  guideWrapper.classList.add("disabled-guide");
              }
          });
      } else {
          allGuides.forEach(checkbox => {
              let guideWrapper = checkbox.closest(".col-lg-3");
              guideWrapper.classList.remove("disabled-guide");
          });
      }
  }

  confirmGuidesButton.addEventListener("click", function () {
      updateSelectedGuidesView();
      $("#guideModal").modal("hide");
  });

  function updateSelectedGuidesView() {
      let selectedCheckboxes = document.querySelectorAll(".guide-checkbox:checked");

      // Resetujemo prikaz
      selectedGuidesDiv.innerHTML = "";
      let chooseBox = document.createElement("div");
      chooseBox.classList.add("col-lg-3", "choose-guide-wrapper");
      chooseBox.innerHTML = `
          <div class="choose-guide" data-toggle="modal" data-target="#guideModal">
              <i class="icon-plus"></i>
          </div>
          <p class="mt-1">Neue auswählen</p>
      `;
      selectedGuidesDiv.appendChild(chooseBox);

      selectedCheckboxes.forEach(checkbox => {
          let name = checkbox.getAttribute("data-name");
          let image = checkbox.getAttribute("data-image");

          let guideDiv = document.createElement("div");
          guideDiv.classList.add("col-lg-3", "selected-guide-box");
          guideDiv.innerHTML = `
              <img src="${image}" class="img-fluid"> 
              <p class="mt-1">${name}</p>
          `;
          selectedGuidesDiv.insertBefore(guideDiv, chooseBox);
      });
  }


  // Request form tourens
 let selectedTourensDiv = document.getElementById("selected-tourens");
    let selectedTourensInput = document.getElementById("selected_tourens_email");
    let selectedTourensNamesInput = document.getElementById("selected_tourens_names");
    let tourenCheckboxes = document.querySelectorAll(".touren-checkbox");
    let confirmTourensButton = document.getElementById("confirmtourens");

    tourenCheckboxes.forEach(checkbox => {
        checkbox.addEventListener("change", function () {
            let selectedCheckboxes = document.querySelectorAll(".touren-checkbox:checked");
            
            if (selectedCheckboxes.length > 4) {
                this.checked = false;
                return;
            }

            updateTourenSelection();
        });
    });

    function updateTourenSelection() {
        let selectedCheckboxes = document.querySelectorAll(".touren-checkbox:checked");
        let allTourens = document.querySelectorAll(".touren-checkbox");
        
        let selectedData = [];
        let selectedNamesData = [];

        allTourens.forEach(checkbox => {
            let tourenWrapper = checkbox.closest(".col-lg-3");

            if (checkbox.checked) {
                tourenWrapper.classList.add("selected-touren");
                if (!tourenWrapper.querySelector(".remove-touren")) {
                    let removeIcon = document.createElement("i");
                    removeIcon.classList.add("icon-close", "remove-touren");
                    removeIcon.addEventListener("click", function () {
                        checkbox.checked = false;
                        updateTourenSelection();
                    });
                    tourenWrapper.appendChild(removeIcon);
                }
            } else {
                tourenWrapper.classList.remove("selected-touren");
                let removeIcon = tourenWrapper.querySelector(".remove-touren");
                if (removeIcon) removeIcon.remove();
            }
        });

        selectedCheckboxes.forEach(checkbox => {
            let name = checkbox.getAttribute("data-name");
            let email = checkbox.getAttribute("data-email");
            selectedData.push(email);
            selectedNamesData.push(name);
        });

        // Ažuriranje skrivenih input polja
        selectedTourensInput.value = selectedData.join(", ");
        selectedTourensNamesInput.value = selectedNamesData.join(", ");

        // Ako su 4 selektovana, ostali postaju manje vidljivi
        if (selectedCheckboxes.length >= 4) {
            allTourens.forEach(checkbox => {
                let tourenWrapper = checkbox.closest(".col-lg-3");
                if (!checkbox.checked) {
                    tourenWrapper.classList.add("disabled-touren");
                }
            });
        } else {
            allTourens.forEach(checkbox => {
                let tourenWrapper = checkbox.closest(".col-lg-3");
                tourenWrapper.classList.remove("disabled-touren");
            });
        }
    }

    confirmTourensButton.addEventListener("click", function () {
        updateSelectedTourensView();
        $("#tourenModal").modal("hide");
    });

    function updateSelectedTourensView() {
        let selectedCheckboxes = document.querySelectorAll(".touren-checkbox:checked");

        // Resetujemo prikaz
        selectedTourensDiv.innerHTML = "";
        let chooseBox = document.createElement("div");
        chooseBox.classList.add("col-lg-3", "choose-touren-wrapper");
        chooseBox.innerHTML = `
            <div class="choose-touren" data-toggle="modal" data-target="#tourenModal">
                <i class="icon-plus"></i>
            </div>
            <p class="mt-1">Neue auswählen</p>
        `;
        selectedTourensDiv.appendChild(chooseBox);

        selectedCheckboxes.forEach(checkbox => {
            let name = checkbox.getAttribute("data-name");
            let image = checkbox.getAttribute("data-image");

            let tourenDiv = document.createElement("div");
            tourenDiv.classList.add("col-lg-3", "selected-touren-box");
            tourenDiv.innerHTML = `
                <img src="${image}" class="img-fluid"> 
                <p class="mt-1">${name}</p>
            `;
            selectedTourensDiv.insertBefore(tourenDiv, chooseBox);
        });
    }



  /*
   * HOTEL
   */
  // Funkcija za dobijanje parametra iz URL-a
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // Uzmimo naziv hotela iz URL parametra
  var hotelTitle = getUrlParameter('hotel_title'); // Prilagodi naziv parametra

  if (hotelTitle) {
    var selectElement = document.getElementById('choosehotel');
    var hiddenElement = document.getElementById('hotel_title');

    if (selectElement) {
      // Postavi odabranu opciju
      for (var i = 0; i < selectElement.options.length; i++) {
        var option = selectElement.options[i];
        if (option.text.indexOf(hotelTitle) !== -1) {
          selectElement.value = option.value;
          break;
        }
      }
    }

    if (hiddenElement) {
      // Postavi vrednost u skriveno polje
      hiddenElement.value = hotelTitle;
    }
  }





  /*
   * ADVENTURE
   */

  // Funkcija za dobijanje parametara iz URL-a
  // Funkcija za dobijanje parametara iz URL-a
  function getQueryParam(param) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  // Preuzmi 'categories' parametar
  var categories = getQueryParam('categories');

  // Ako postoji 'categories', postavi selektovani deo u select box
  if (categories) {
    var selectElement = document.getElementById('activities');
    if (selectElement) {
      var options = selectElement.options;
      var categoriesArray = categories.split(', ');

      for (var i = 0; i < options.length; i++) {
        if (categoriesArray.indexOf(options[i].text) > -1) {
          options[i].selected = true;
        }
      }
    }
  }

  // Preuzmi 'adventure_title' parametar i upiši ga u polje
  var adventureTitle = getQueryParam('adventure_title');

  if (adventureTitle) {
    var activitiesNameElement = document.querySelector('[id="activities_name"]');
    if (activitiesNameElement) {
      activitiesNameElement.value = decodeURIComponent(adventureTitle.replace(/\+/g, ' '));
    }
  }

  // Preuzmi 'guide_title' parametar iz URL-a i postavi ga u skriveno polje
  var guideTitle = getQueryParam('guide_title');

  // Ako postoji 'guide_title' u URL-u, postavi ga u skriveno polje
  if (guideTitle) {
    var guideTitleElement = document.querySelector('[id="guide_title"]');
    if (guideTitleElement) {
      guideTitleElement.value = guideTitle;
    }
  } else {
    // Ako 'guide_title' nije prisutan u URL-u, uzmi iz select boxa
    var guideSelectElement = document.getElementById('guide');
    if (guideSelectElement) {
      var selectedOption = guideSelectElement.options[guideSelectElement.selectedIndex];
      if (selectedOption) {
        var guideName = selectedOption.text.split('|')[0].trim(); // Uzimamo samo deo pre '|' (ime vodiča)

        var guideTitleElement = document.querySelector('[id="guide_title"]');
        if (guideTitleElement) {
          guideTitleElement.value = guideName;
        }
      }
    }
  }

  // Dodaj event listener za promenu u select elementu za vodiče
  var guideSelectElement = document.getElementById('guide');
  if (guideSelectElement) {
    guideSelectElement.addEventListener('change', function () {
      var selectedOption = guideSelectElement.options[guideSelectElement.selectedIndex];
      if (selectedOption) {
        var guideName = selectedOption.text.split('|')[0].trim(); // Uzimamo samo deo pre '|' (ime vodiča)

        var guideTitleElement = document.querySelector('[id="guide_title"]');
        if (guideTitleElement) {
          guideTitleElement.value = guideName;
        }
      }
    });
  }






  /*
   * GUIDE
   */

  function selectGuideFromURL() {
    // Preuzmi URL parametar 'guide_title'
    const urlParams = new URLSearchParams(window.location.search);
    const guideTitle = urlParams.get('guide_title');

    // Ako postoji parametar 'guide_title'
    if (guideTitle) {
      // Traži selekt u formi
      const guideSelect = document.getElementById('guide');

      if (guideSelect) {
        // Postavi selektovanu opciju
        for (let i = 0; i < guideSelect.options.length; i++) {
          if (guideSelect.options[i].value === guideTitle) {
            guideSelect.selectedIndex = i;
            break;
          }
        }
      }
    }
  }

  // Pozovi funkciju kada se stranica učita
  selectGuideFromURL();
});



// Single guide form
document.addEventListener('DOMContentLoaded', function() {
  // Dobijanje celog URL-a
  var url = window.location.href;  // Koristi celo URL-a
  console.log("Full URL: " + url);  // Ovo će ti pokazati ceo URL

  // Uklonimo eventualnu završnu kosu crtu
  if (url.endsWith('/')) {
      url = url.slice(0, -1);  // Uklanja poslednji karakter ako je '/'
  }

  // Dobijanje poslednjeg dela URL-a (slug vodiča)
  var guideSlug = url.split('/').pop();  // Uzimamo poslednji segment URL-a
  console.log("Vodič Slug: " + guideSlug);  // Ovo bi trebalo da prikaže poslednji segment URL-a

  // U slučaju da je guideSlug prazan, proveri URL format
  if (!guideSlug) {
      console.error("Nema vodiča u URL-u, proverite format URL-a.");
  }

  // Pronalaženje select elementa
  var selectElement = document.getElementById('guide');
  if (selectElement) {
      var options = selectElement.options;

      // Poređenje URL imena sa vrednostima u select opcijama
      for (var i = 0; i < options.length; i++) {
          // Kreiramo identifikator imena vodiča u formatu koji odgovara opcijama
          var guideOptionValue = options[i].text.toLowerCase().replace(/ /g, '-').split('|')[0].trim().toLowerCase();
          console.log("Vrednost opcije: " + guideOptionValue); // Za debagovanje

          // Ako se vrednost iz URL-a poklapa sa imenom vodiča u opciji, selektuj opciju
          if (guideSlug === guideOptionValue) {
              options[i].selected = true; // Postavi selektovanog vodiča
              console.log("Selekcija: " + options[i].text); // Potvrda da je selektovana opcija
              break;
          }
      }
  }

  // Popunjavanje skrivenog polja 'guide_title' sa nazivom stranice (title)
  var pageTitle = document.title; // Uzima naziv stranice
  console.log("Naziv stranice: " + pageTitle); // Za debagovanje

  // Izdvajanje samo prvog dela imena (pre "–")
  var guideName = pageTitle.split(" –")[0].trim();
  console.log("Ime vodiča: " + guideName); // Za debagovanje

  // Pronalaženje skrivenog polja i popunjavanje
  var hiddenGuideTitle = document.getElementById('guide_title');
  if (hiddenGuideTitle) {
      hiddenGuideTitle.value = guideName;  // Popunjava skriveno polje sa imenom vodiča
      console.log("Popunjeno 'guide_title' polje: " + guideName); // Potvrda
  } else {
      console.error("Nije pronađeno polje za 'guide_title'.");
  }
});

/*
*  BIG MENU
*/

document.addEventListener("DOMContentLoaded", function () {
	const menuWrapper = document.querySelector('.body-big-menu');
	if (!menuWrapper) return;

	const menuHeight = menuWrapper.offsetHeight;

	// Postavi visinu i dodaj title div u sve .sub-menu
	document.querySelectorAll('.body-big-menu .sub-menu').forEach(sub => {
		sub.style.height = menuHeight + 'px';

		// Ako već nema naslov, dodaj ga
		if (!sub.querySelector('.menu-title')) {
			const titleDiv = document.createElement('div');
			titleDiv.classList.add('menu-title');
			titleDiv.textContent = 'Submenu'; // default
			sub.insertBefore(titleDiv, sub.firstChild);
		}
	});

	// Klik na strelicu
	document.querySelectorAll('.body-big-menu .toggle-submenu').forEach(toggle => {
		toggle.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			const parentItem = this.closest('.menu-item-has-children');
			const submenu = parentItem.querySelector('.sub-menu');
			const clickedText = parentItem.querySelector('a').childNodes[0].nodeValue.trim();

			// Zatvori druge
			document.querySelectorAll('.body-big-menu .sub-menu').forEach(menu => {
				if (menu !== submenu && !menu.contains(submenu)) {
					menu.classList.remove('open');
				}
			});

			// Otvori submenu i poravnaj ga gore
			if (submenu) {
				submenu.classList.toggle('open');

				// Postavi naslov
				const title = submenu.querySelector('.menu-title');
				if (title) title.textContent = clickedText;

				// Izračunaj offset za top
				const parentRect = parentItem.getBoundingClientRect();
				const wrapperRect = menuWrapper.getBoundingClientRect();
				const offsetTop = parentRect.top - wrapperRect.top;
				submenu.style.top = `-${offsetTop}px`;
			}
		});
	});
});



(function ($) {
  $(function () {

  

    // Big menu
    $('.big-menu-click').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.big-menu').toggleClass('opened');
      $('.overlay-big-menu').addClass('active');

    });

    $('.big-menu-click.active').on('click', function () {
      $(this).removeClass('active');
      $('.big-menu.opened').removeClass('opened');
    });

    //Remove opend class for cart
    $('.guide-book-close').on('click', function () {
      $(this).removeClass('opened');
      $('.big-menu').removeClass('opened');
      $('.big-menu-click').removeClass('active');
      $('.overlay-big-menu').removeClass('active');
 
    });


    // Single guide form
    $('.book-now-btn').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.guide-book').toggleClass('opened');
      $('.overlay-black-guide').addClass('active');

    });

    $('.book-now-btn.active').on('click', function () {
      $(this).removeClass('active');
      $('.guide-book.opened').removeClass('opened');
    });

    //Remove opend class for cart
    $('.guide-book-close').on('click', function () {
      $(this).removeClass('opened');
      $('.guide-book').removeClass('opened');
      $('.book-now-btn').removeClass('active');
      $('.overlay-black-guide').removeClass('active');

      $('.navigation-bottom.mobile').toggleClass('hide');
    });

    // Contact form see alternative dates
    $('span[data-name="show-alter"] input[type="checkbox"]').change(function () {
      if ($(this).is(':checked')) {
        $('.alter_start_date, .alter_end_date').slideDown();
      } else {
        $('.alter_start_date, .alter_end_date').slideUp();
      }
    });

    $("#start-date, .start_date input, .alter_start_date input").attr("placeholder", "Datum auswählen");
    $("#end-date, .end_date input, .alter_end_date input").attr("placeholder", "Datum auswählen");

    // Home date input guide
    $("#start-date, .start_date input, .alter_start_date input").datepicker({
      dateFormat: "dd/mm/yy",
      changeMonth: true,
      showOtherMonths: true,
      selectOtherMonths: true,
      changeYear: true,
      onSelect: function (selectedDate) {
        var minDate = $(this).datepicker('getDate');
        minDate.setDate(minDate.getDate() + 1); // Dodajte jedan dan
        $("#end-date, .end_date input, .alter_end_date input").datepicker("option", "minDate", minDate);

        // Ako je trenutni end-date pre nego što je start-date, postavite end-date na start-date + 1
        var currentEndDate = $("#end-date").datepicker('getDate');
        if (currentEndDate && currentEndDate < minDate) {
          $("#end-date, .end_date input, .alter_end_date input").datepicker('setDate', minDate);
        }
      }
    });
    $("#end-date, .end_date input, .alter_end_date input").datepicker({
      dateFormat: "dd/mm/yy",
      changeMonth: true,
      showOtherMonths: true,
      selectOtherMonths: true,
      changeYear: true
    });

    // var date = new Date();
    // date.setDate(date.getDate() - 1);

    // // Inicijalizacija datepickera za start_date
    // $('#form .start_date input, .wpcf7-form .start_date input, #form .alter_start_date input, .wpcf7-form .alter_start_date input').datepicker({
    //   startDate: date,
    //   format: 'dd. mm. yyyy',
    //   autoclose: true // Zatvori datepicker nakon izbora datuma
    // }).on('changeDate', function (selected) {
    //   // Omogući end_date nakon izbora start_date
    //   $('#form .end_date input, .wpcf7-form .end_date input, #form .alter_end_date input, .wpcf7-form .alter_end_date input').prop('disabled', false);

    //   // Postavi startDate za end_date na izabrani datum start_date + 1 dan
    //   var startDatePlusOne = new Date(selected.date); 
    //   startDatePlusOne.setDate(startDatePlusOne.getDate() + 1);
    //   $('#form .end_date input, .wpcf7-form .end_date input, #form .alter_end_date input, .wpcf7-form .alter_end_date input').datepicker('setStartDate', startDatePlusOne);
    // });

    // // Inicijalizacija datepickera za end_date (početno onemogućen)
    // $('#form .end_date input, .wpcf7-form .end_date input, #form .alter_end_date input, .wpcf7-form .alter_end_date input').prop('disabled', true).datepicker({
    //   startDate: date,
    //   format: 'dd. mm. yyyy',
    //   autoclose: true // Zatvori datepicker nakon izbora datuma
    // });

    $('.nav-button').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.navigation-floating').toggleClass('opened');
      $('.overlay-black').addClass('active');

    });

    $('.nav-button.active').on('click', function () {
      $(this).removeClass('active');
      $('.navigation-floating.opened').removeClass('opened');
    });

    /*
     * Navbar fixed 
     */
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 1) {
        $('.site-header').addClass('navbar-fixed-top fadeInDown animated');
      } else {
        $('.site-header').removeClass('navbar-fixed-top fadeInDown animated');
      }
    });

    /*
     * Toggle burger menu on mobile
     */
    $('.menu-btn-burger').on('click', function () {
      $('#nav-icon').toggleClass('open-custom-menu');
      $(".mobile-menu").toggleClass('sliding-open');
    });

    /* 
     * Owl carousel
     */
    $('.owl-hotel').owlCarousel({
      margin: 20,
      items: 3,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4500,
      center: true,
      nav: false,
      dots: true,
      animateOut: 'fadeOut',
      navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
      // navContainer: '#customNav',
      responsive: {
        0: {
          items: 1
        },
        700: {
          items: 2,
        },
        1200: {
          items: 3,
        }
      },
    });

    /*
     * Video modal 
     */
    $("body").on("click", "#play-video-modal", function (e) {
      e.preventDefault();
      $("#video-modal").modal("show");
      $("#video-modal iframe")[0].src += "?autoplay=1";
    });

    $("#video-modal").on('hidden.bs.modal', function (e) {
      var videoUrl = $("#video-modal iframe")[0].src;
      videoUrl = videoUrl.replace("?autoplay=1", "");
      $("#video-modal iframe")[0].src = videoUrl;
    });

    /*
     * Youtube lazy loading
     */
    $('#play-video-btn').on('click', function (e) {
      e.preventDefault();
      $('#youtubeModal').modal('show');
    });

    $("#youtubeModal").on('hidden.bs.modal', function (e) {
      $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
    });



    /*
     * Scroll up button
     */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.scroll-to-top').addClass('show');
      } else {
        $('.scroll-to-top').removeClass('show');
        $('.scroll-to-top').addClass('animated bounceOutDown');
        $('.scroll-to-top').removeClass('animated bounceOutUp');
        $('.scroll-to-top i').css('transform', 'rotateY(0) scale(1)');
      }
    });

    $('.scroll-to-top').on("click", function () {
      $('.scroll-to-top').addClass('animated bounceOutUp');
      $('.scroll-to-top i').css('transform', 'rotateY(180deg) scale(1.2)');
      $("html, body").animate({
        scrollTop: 0
      }, 1000);
      return false;
    });

    /*
     * Lightbox gallery
     */
    $('.gallery-images').lightGallery({
      selector: '.gallery-item',
      share: true,
      download: true,
      rotate: false,
      showThumbByDefault: true,
      loop: false,
      slideEndAnimatoin: false,
      thumbnail: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      youtubePlayerParams: {
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        modestbranding: 1,
        showinfo: 0,
        rel: 0
      }
    });



    /*
     * Mmenu light 
     */
    var menu = new MmenuLight(
      document.querySelector('#my-menu'),
      'all'
    );
    if (menu) {
      var navigator = menu.navigation({
        // selectedClass: 'Selected',
        // slidingSubmenus: true,
        theme: 'light',
        title: 'Menü'
      });

      var drawer = menu.offcanvas({
        position: 'right'
      });

      //  Open the menu.
      document.querySelector('#nav-icon')
        .addEventListener('click', evnt => {
          evnt.preventDefault();
          drawer.open();
        });

      $(".mob-menu-close").click(function () {
        drawer.close();
      });
    }

  });
})(jQuery);